import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LegalProviderModel} from "../_models/settings/legal-provider-model";
import {Observable} from "rxjs";
import {ServerEndpoints} from "../../../server.endpoints";
import {LegalAccountState} from "../_models/_enums/legal-account-state";
import {LegalType} from "../_models/_enums/legal-type";
import {LegalProvider} from "../_models/_enums/legal-provider";

@Injectable({
  providedIn: 'root'
})
export class SettingsHttpService {
  constructor(@Inject('BASE_URL') private baseUrl: string, private httpClient: HttpClient) {
  }

  /**
   * (#633) Every method here takes an optional `shardId`. Omitted, it targets the tenant route (`/legal/…`),
   * scoped by the caller's own context token — this is `SettingsComponent`'s TENANT MODE. Given, it targets
   * the owner-area management route (`/management/legal/{shardId}/…`) instead, PlatformOwner-only, with the
   * shard carried explicitly — `SettingsComponent`'s OWNER MODE, reached only from the OWNER area, where a
   * `PlatformOwner` session (never narrowed to a tenant context) can name any shard by id.
   */

  list(shardId?: string): Observable<LegalProviderModel[]> {
    const url = shardId
      ? ServerEndpoints.Management_Legal_Settings_List.dictReplace({shardId})
      : ServerEndpoints.Legal_Settings_List;
    return this.httpClient.get<LegalProviderModel[]>(`${this.baseUrl}${url}`);
  }

  isConfigured(type: LegalType, shardId?: string): Observable<LegalAccountState> {
    const url = shardId
      ? ServerEndpoints.Management_Legal_Settings_IsConfigured.dictReplace({shardId})
      : ServerEndpoints.Legal_Settings_IsConfigured;
    return this.httpClient.get<LegalAccountState>(`${this.baseUrl}${url}?type=${type}`);
  }

  setCredentials(key: string, secret: string, type: LegalType, shardId?: string): Observable<LegalAccountState> {
    const url = shardId
      ? ServerEndpoints.Management_Legal_Settings_SetCredentials.dictReplace({shardId})
      : ServerEndpoints.Legal_Settings_SetCredentials;
    return this.httpClient.post<LegalAccountState>(`${this.baseUrl}${url}?type=${type}`,
      {
        name: key,
        password: secret
      });
  }

  selectProvider(type: LegalType, provider: LegalProvider, shardId?: string): Observable<LegalAccountState> {
    const url = shardId
      ? ServerEndpoints.Management_Legal_Settings_SelectProvider.dictReplace({shardId})
      : ServerEndpoints.Legal_Settings_SelectProvider;
    return this.httpClient.post<LegalAccountState>(`${this.baseUrl}${url}?type=${type}&provider=${provider}`, null);
  }
}
